/* eslint-disable import/first, import/newline-after-import */

import EezyStimulusApplication from 'packs/eezy-stimulus'; // eslint-disable-line import/order

import 'components/search/search-sidebar/search-sidebar';
import 'components/search/search-filters/search-filters';
import 'components/util/ez-double-range/ez-double-range';

import SearchFiltersController from 'components/search/search-filters/search-filters-controller';
EezyStimulusApplication.register('search-filters', SearchFiltersController);

import DurationRangeController from 'components/util/ez-double-range/duration-range-controller';
EezyStimulusApplication.register('duration-range', DurationRangeController);

import ColorFilterController from 'components/search/search-filters/color-filter-controller';
EezyStimulusApplication.register('color-filter', ColorFilterController);
